import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { getTageKeyByValue } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { useTranslation } from 'react-i18next';

export function ExaktValues() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;

  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.label',
        )}
      </span>
      <div>
        {data.bezahlung.arbeitszeitkonto.arbeitstage
          .sort((a, b) => a - b)
          .map((arbeitstag, index) => (
            <span
              key={`${arbeitstag}-${index}`}
              className="text-neutrals-900 font-semibold">
              {t(
                'general.date.days.' + getTageKeyByValue(arbeitstag) + 'Short',
              )}
              {'.'}
              {index < data.bezahlung.arbeitszeitkonto.arbeitstage.length - 1 &&
                ', '}
            </span>
          ))}
      </div>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {data.bezahlung.arbeitszeitkonto.tagessoll +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.tagessoll.zusammenfassungSuffix',
          )}
      </span>
    </>
  );
}
